import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import TwinPage from "@/pages/TwinPage";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<TwinPage />} />
          <Route path="*" element={<TwinPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1c1b18",
            color: "#fbfaf7",
            border: "1px solid #1c1b18",
            borderRadius: 0,
            fontFamily: "Inter, sans-serif",
            fontSize: "13px",
            letterSpacing: "0.04em",
          },
        }}
      />
    </div>
  );
}

export default App;
